import React, { useState } from 'react';
import { Trash2, Download } from 'lucide-react';

// Delete (every coach) and Word download (EMIT Research) for one conversation
// in a history list. Backend: api/routes/conversation_tools.py (Sep 29 2026).
const API = process.env.REACT_APP_API_URL || '';

export default function ConversationActions({ app, conversationId, onDeleted, canExport = false, color = '#6b7280' }) {
  const [busy, setBusy] = useState(false);
  if (!conversationId) return null;
  const auth = () => ({ Authorization: `Bearer ${localStorage.getItem('token')}` });

  const handleDelete = async (e) => {
    e.stopPropagation();
    if (busy) return;
    if (!window.confirm("Delete this conversation? This can't be undone.")) return;
    setBusy(true);
    try {
      const res = await fetch(`${API}/api/v1/chats/${app}/${encodeURIComponent(conversationId)}`,
        { method: 'DELETE', headers: auth() });
      if (res.ok || res.status === 404) {
        if (onDeleted) onDeleted(conversationId);
      } else {
        alert('Could not delete this conversation. Please try again.');
      }
    } catch (err) {
      alert('Could not delete this conversation. Please try again.');
    }
    setBusy(false);
  };

  const handleExport = async (e) => {
    e.stopPropagation();
    if (busy) return;
    setBusy(true);
    try {
      const res = await fetch(
        `${API}/api/v1/emit-research/conversations/${encodeURIComponent(conversationId)}/export`,
        { headers: auth() });
      if (!res.ok) throw new Error(String(res.status));
      const blob = await res.blob();
      const match = (res.headers.get('Content-Disposition') || '').match(/filename="([^"]+)"/);
      const a = document.createElement('a');
      a.href = URL.createObjectURL(blob);
      a.download = match ? match[1] : 'EMIT-Research.docx';
      document.body.appendChild(a);
      a.click();
      a.remove();
      setTimeout(() => URL.revokeObjectURL(a.href), 1000);
    } catch (err) {
      alert('Could not prepare the download. Please try again.');
    }
    setBusy(false);
  };

  const btn = {
    background: 'transparent', border: 'none', color, cursor: busy ? 'wait' : 'pointer',
    padding: '4px 6px', display: 'inline-flex', alignItems: 'center', gap: '4px', fontSize: '12px',
  };
  return (
    <div style={{ display: 'flex', justifyContent: 'flex-end', gap: '6px', marginTop: '8px' }}>
      {canExport && (
        <button type="button" onClick={handleExport} style={btn} disabled={busy}
          title="Download as a Word document" aria-label="Download conversation as a Word document">
          <Download size={14} /> Word
        </button>
      )}
      <button type="button" onClick={handleDelete} style={btn} disabled={busy}
        title="Delete conversation" aria-label="Delete conversation">
        <Trash2 size={14} /> Delete
      </button>
    </div>
  );
}
